<script setup lang="ts">
    import type { HTMLAttributes } from "vue";

    import { useApp } from "@/stores/app";

    const app = useApp();

    interface Props {
        svg: string;
        size?: number;
        invertColor?: boolean;

        class?: HTMLAttributes["class"];
        alt?: string;
    }

    const props = withDefaults(defineProps<Props>(), {
        size: 24,
        invertColor: false,
    });

    const invert = computed<boolean>(() => props.invertColor && !app.isDarkMode);
</script>

<template>
    <img
        :src="props.svg"
        :style="{ width: `${props.size}rem` }"
        :class="{ invert: invert }"
        v-bind="props"
    />
</template>

<style scoped lang="scss">

</style>